export default __webpack_public_path__ + "static/media/shine.78854d08.webp";